<template>
  <hr v-if="isTotal && sectionWise" style="height:1px;border:none;color:#333;background-color:#333;">
  <div v-if="sectionWise || isGrandTotal || !isTotal"
      class="d-flex justify-content-between align-items-end"
  >
    <div v-if="isTotal"> Total </div>
    <div v-else-if="!isTotal && sectionWise && section"> {{ section.name ?? 'Unassigned' }} </div>
    <div v-else-if="sectionWise"></div>

    <a v-if="type === 'gender_wise'" :href="studentsDetailUrl({...filter, gender: 'm'})">
      {{
        Math.round(
        studentsFilteredBy({...filter, gender: 'm'}).sum('student_count') * (isPercentage ? 100 : 1)
        /(isPercentage ? studentsFilteredBy(filter).sum('student_count') : 1)
        ) + (isPercentage ? '%' : '')
      }}
      </a>
    <a v-if="type === 'gender_wise'" :href="studentsDetailUrl({...filter, gender: 'f'})">
      {{
        Math.round(
        studentsFilteredBy({...filter, gender: 'f'}).sum('student_count') * (isPercentage ? 100 : 1)
        /(isPercentage ? studentsFilteredBy(filter).sum('student_count') : 1)
        ) + (isPercentage ? '%' : '')
      }}
    </a>
    <a v-if="type === 'group_wise'" :href="studentsDetailUrl({...filter, group_name: 'science'})">
      {{
        Math.round(
        studentsFilteredBy({...filter, group_name: 'science'}).sum('student_count') * (isPercentage ? 100 : 1)
        /(isPercentage ? studentsFilteredBy(filter).sum('student_count') : 1)
        ) + (isPercentage ? '%' : '')
      }}
    </a>
    <a v-if="type === 'group_wise'" :href="studentsDetailUrl({...filter, group_name: 'commerce'})">
      {{
        Math.round(
        studentsFilteredBy({...filter, group_name: 'commerce'}).sum('student_count') * (isPercentage ? 100 : 1)
        /(isPercentage ? studentsFilteredBy(filter).sum('student_count') : 1)
        ) + (isPercentage ? '%' : '')
      }}
    </a>
    <a v-if="type === 'group_wise'" :href="studentsDetailUrl({...filter, group_name: 'arts'})">
      {{
        Math.round(
        studentsFilteredBy({...filter, group_name: 'arts'}).sum('student_count') * (isPercentage ? 100 : 1)
        /(isPercentage ? studentsFilteredBy(filter).sum('student_count') : 1)
        ) + (isPercentage ? '%' : '')
      }}
    </a>
    <a v-if="type === 'residential_status_wise'" :href="studentsDetailUrl({...filter, residential_status: 'resident'})">
      {{
        Math.round(
        studentsFilteredBy({...filter, residential_status: 'resident'}).sum('student_count') * (isPercentage ? 100 : 1)
        /(isPercentage ? studentsFilteredBy(filter).sum('student_count') : 1)
        ) + (isPercentage ? '%' : '')
      }}
    </a>
    <a v-if="type === 'residential_status_wise'" :href="studentsDetailUrl({...filter, residential_status: 'non_resident'})">
      {{
        Math.round(
        studentsFilteredBy({...filter, residential_status: 'non_resident'}).sum('student_count') * (isPercentage ? 100 : 1)
        /(isPercentage ? studentsFilteredBy(filter).sum('student_count') : 1)
        ) + (isPercentage ? '%' : '')
      }}
    </a>
    <a v-if="type === 'residential_status_wise'" :href="studentsDetailUrl({...filter, residential_status: 'vip_resident'})">
      {{
        Math.round(
        studentsFilteredBy({...filter, residential_status: 'vip_resident'}).sum('student_count') * (isPercentage ? 100 : 1)
        /(isPercentage ? studentsFilteredBy(filter).sum('student_count') : 1)
        ) + (isPercentage ? '%' : '')
      }}
    </a>
    <a v-if="type === 'residential_status_wise'" :href="studentsDetailUrl({...filter, residential_status: 'day_care'})">
      {{
        Math.round(
        studentsFilteredBy({...filter, residential_status: 'day_care'}).sum('student_count') * (isPercentage ? 100 : 1)
        /(isPercentage ? studentsFilteredBy(filter).sum('student_count') : 1)
        ) + (isPercentage ? '%' : '')
      }}
    </a>
    <a v-if="type === 'religion_wise'" v-for="religion in distinctValues({}, 'religion')" :href="studentsDetailUrl({...filter, religion: religion.name})">
      {{
        Math.round(
        studentsFilteredBy({...filter, religion: religion.name}).sum('student_count') * (isPercentage ? 100 : 1)
        /(isPercentage ? studentsFilteredBy(filter).sum('student_count') : 1)
        ) + (isPercentage ? '%' : '')
      }}
    </a>
    <a v-if="type === 'location_wise'" v-for="location in distinctValues({}, 'location')" :href="studentsDetailUrl({...filter, location_id: location.id})">
      {{
        Math.round(
            studentsFilteredBy({...filter, location_id: location.id}).sum('student_count') * (isPercentage ? 100 : 1)
            /(isPercentage ? studentsFilteredBy(filter).sum('student_count') : 1)
        ) + (isPercentage ? '%' : '')
      }}
    </a>
    <a v-if="type === 'hifz_group_wise'" v-for="hifzGroup in distinctValues({}, 'hifz_group')" :href="studentsDetailUrl({...filter, hifz_group_id: hifzGroup.id})">
      {{
        Math.round(
         studentsFilteredBy({...filter, hifz_group_id: hifzGroup.id}).sum('student_count') * (isPercentage ? 100 : 1)
         /(isPercentage ? studentsFilteredBy(filter).sum('student_count') : 1)
        ) + (isPercentage ? '%' : '')
      }}
    </a>
    <a :href="studentsDetailUrl(filter)">
      {{ isPercentage ? '' : studentsFilteredBy(filter).sum('student_count') }}
    </a>
  </div>

  <a v-else-if="isTotal || isGrandTotal" :href="studentsDetailUrl(filter)">
    {{ studentsFilteredBy(filter).sum('student_count') }}
  </a>
</template>

<script>
import {Collection} from "collect.js";

export default {
  props: {
    type: String,
    session: Number,
    studentCounts: Collection,
    filter: Object,
    section: Object,
    isTotal: Boolean,
    isGrandTotal: Boolean,
    isPercentage: Boolean,
    sectionWise: Boolean,
  },
  setup(props) {
    const filter = props.filter;
    if (!props.isTotal && props.section) {
       filter['section_id'] = props.section.id;
    }
    return {
      filter: filter
    };
  },
  methods: {
    studentsFilteredBy(filter) {
      if (this.session) {
        filter['session_id'] = this.session;
      }

      return this.studentCounts.filter((count) => {
        return Object.keys(filter).every(key => count[key] === filter[key]);
      });
    },
    distinctValues(filter, valueKey) {
      return this.studentsFilteredBy(filter)
          .map((count) => { return {id: count[valueKey+'_id'] ?? count[valueKey], name: count[valueKey]} }).unique('id');
    },
    studentsDetailUrl(filter) {
      const updatedFilter = {};
      for (const key in filter) {
        if (Object.prototype.hasOwnProperty.call(filter, key)) {
          let newKey = key.split('_id')[0];
          newKey = newKey.split('_name')[0];
          updatedFilter[newKey] = filter[key];
        }
      }
      if (this.session) {
        updatedFilter['session'] = this.session;
      }

      return route('students.index', updatedFilter);
    }
  }
}
</script>

<style scoped>
.table th div{
  padding: 0.5rem;
}
</style>